import { Component, Input, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'ftr-link-grid-item',
  templateUrl: './link-grid-item.component.html',
  styleUrls: ['./link-grid-item.component.css'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'col-12 col-md-6 col-lg-4' },
})
/*
 * Displays a list of links with a header and a description. Used on
 * category pages
 */
export class LinkGridItemComponent {
  @Input() linkTitle: string
  @Input() description: string
  /**
   * A short label displayed on the header. Ideally this should indicate
   * the status of the item being displayed (e.g. enabled or disabled).
   */
  @Input() label?: string
  /**
   * Whether the description is written in Markdown. If so, it will be
   * rendered with marked parser.
   */
  @Input() markdown?: boolean
}
